export default "__VITE_ASSET__ByB9X5Be__"